import styled from "@emotion/styled";

export const TruckThankYouHeader = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	display: "flex",
	flexDirection: "column",
	gap: 16,
	margin: "0px 0px 8px 0px",
	padding: "24px",
	position: "sticky",
	top: 0,
	zIndex: "98",
	h5: {
		color: theme.project.colors.fontColors.main,
		paddingBottom: 16,
		margin: 0
	},
	div: {
		...theme.project.typography.body.body1,
		color: theme.project.colors.fontColors.secondary,
		display: "flex",
		justifyContent: "space-between"
	},
	button: {
		width: "max-content"
	},
	[theme.breakpoints.down("lg")]: {
		width: "calc(100% - 40px)" // 100v%- header-paddings (under lg mobile view, top nav is present & does not effect width of header)
	},
	[theme.breakpoints.down("md")]: {
		position: "unset",
		top: "unset",
		width: "unset"
	}
}));
